<div style="margin-top: 20px"></div>


<div style="padding: 10px 10px;">
    <dx-toolbar style="padding-right: 30px;">
        <dxi-item name="groupPanel"></dxi-item>
        <dxi-item location="after">            
            <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
            (onClick)="exportExcel($event)" [disabled]="childDataGrids.length == 0">
            </dx-button>
        </dxi-item>
        <dxi-item name="searchPanel"></dxi-item>
    </dx-toolbar>

    <div style="margin-top: 10px"></div>
    
    <div>
        <dx-tab-panel
            #crmChildTabPanel
            [height]="'auto'"  
            [selectedIndex]="0"
            [loop]="false"
            [animationEnabled]="false"
            [swipeEnabled]="false"
            [deferRendering]="false"            
            [visible]="true">
            <dxi-item [title]="'All Leads'">
                <div class="heading-box">                    
                    <h4 class="heading">{{allLeadsDetails_heading1}}</h4>                    
                </div>
                <app-crm-report-datagrid 
                    [reportRequest]="reportRequest" 
                    [reportType]="'LeadsWith91MA_AllLeadsDetails'"
                    (dataGridCreated)="onDataGridCreated($event)">
                </app-crm-report-datagrid>  
            </dxi-item>
            <dxi-item [title]="'Open Leads'" #OpenLeadsTab>
                <div class="heading-box">                    
                    <h4 class="heading">{{openLeads_heading1}}</h4>                    
                </div>
                <div style="margin-top: 20px;"></div>
                <h5 class="content-block ap-green">Count of Leads</h5>
                <div style="margin-top: 20px;"></div>
                <dx-pivot-grid #OpenLeadsTerrFYQtr id="openLeadsTerrFYQtr" class="fixMinGridHeight"
                    [allowSortingBySummary]="true" [allowFiltering]="false"
                    [showBorders]="true" [showColumnGrandTotals]="true" [showRowGrandTotals]="true" [showRowTotals]="false"
                    [showColumnTotals]="false" [dataSource]="pivotGrid_OpenLeadsTerrFYQtr_Datasource">
                    <dxo-field-chooser [enabled]="false"></dxo-field-chooser>
                    <dxo-field-panel
                        [showDataFields]="false"
                        [showRowFields]="true"
                        [showColumnFields]="false"
                        [showFilterFields]="false"
                        [allowFieldDragging]="false"
                        [visible]="true">
                    </dxo-field-panel>
                    <dxo-scrolling mode="virtual"></dxo-scrolling> 
                    <dxo-load-panel [enabled]="false"></dxo-load-panel>                   
                </dx-pivot-grid>
                <div style="margin-top: 40px;"></div>
                <h5 class="content-block ap-green">Open Leads by Campaign</h5>
                <div style="margin-top: 20px;"></div>
                <dx-pivot-grid #OpenLeadsByCampaign id="openLeadsByCampaign" class="fixMinGridHeight"
                    [allowSortingBySummary]="true" [allowFiltering]="false"
                    [showBorders]="true" [showColumnGrandTotals]="true" [showRowGrandTotals]="true" [showRowTotals]="true"
                    [showTotalsPrior]="'none'" [showColumnTotals]="false" [dataSource]="pivotGrid_OpenLeadsByCampaign_Datasource">
                    <dxo-field-chooser [enabled]="false"></dxo-field-chooser>
                    <dxo-field-panel
                        [showDataFields]="false"
                        [showRowFields]="true"
                        [showColumnFields]="true"
                        [showFilterFields]="false"
                        [allowFieldDragging]="false"
                        [visible]="true">
                    </dxo-field-panel>
                    <dxo-scrolling mode="virtual"></dxo-scrolling> 
                    <dxo-load-panel [enabled]="false"></dxo-load-panel>                   
                </dx-pivot-grid>   
                <dx-load-panel #openLeads_loadpanel container="#OpenLeadsTab" shadingColor="rgba(0,0,0,0.4)" 
                    [showPane]="true" [shading]="false"></dx-load-panel>                             
            </dxi-item>                                                         
        </dx-tab-panel>
    </div>
</div>
